import BaseAuthApi from '@/api/config/BaseAuthApi';
import ErrorUtil from '@/utils/ErrorUtil';

export class InventoryManagementApi extends BaseAuthApi {
    async moveInventory(currentLocatorRef, newLocatorRef) {
        try {
            const response = await this.get(`serialitem/${currentLocatorRef}/move?new_locator_ref=${newLocatorRef}`);

            return response.data?.list ?? [];
        } catch (error) {
            return new Error(ErrorUtil.getMessageFromError(error));
        }
    }

    async getSerialItems(locatorRef, includeListingData = true) {
        try {
            return (await this.get(`locator/${locatorRef}/serialitems?includeListingData=${includeListingData}`)).data.list;
        } catch (error) {
            return new Error(ErrorUtil.getMessageFromError(error));
        }
    }

    async updateSerialItemLocator(barcode, locatorRef) {
        try {
            return (await this.get(`physicalinventory/${barcode}/scan?locator_ref=${locatorRef}`)).data.list;
        } catch (error) {
            return new Error(ErrorUtil.getMessageFromError(error));
        }
    }
}
